import React from "react"
import uuidv1 from "uuid/v1"
import ActionWrapper from "containers/ActionWrapper"
import {
  BriefDescription,
  FullDescription,
  Header,
  Segment,
  CampInformation,
  Title,
  Body,
  Info,
  InfoColumn,
  InfoDetail,
  InfoTitle,
  BulletItem,
  CampExpertise,
  CampSpecialty,
} from "./index"

import style from "utils/style"

class CampProfileLoading extends React.Component {
  render() {
    return (
      <ActionWrapper title="Camp name" loading>
        <Header loading>
          <BriefDescription>Description Text</BriefDescription>
          <FullDescription>Fuller Description Text</FullDescription>
        </Header>
        <Segment backgroundColor={style.colors.lightMintGreen} loading>
          <CampInformation>
            <Title>Camp Information</Title>
            <Body>
              <InfoColumn>
                <Info>
                  <InfoTitle>Session Dates</InfoTitle>
                  <InfoDetail>2017-01-01 to 2017-12-31</InfoDetail>
                </Info>
                <Info>
                  <InfoTitle>Address</InfoTitle>

                  <InfoDetail>1600 Address Dr</InfoDetail>
                  <InfoDetail>City, ST 10101</InfoDetail>
                  <InfoDetail>Country</InfoDetail>
                </Info>
                <Info>
                  <InfoTitle>Dates and rates</InfoTitle>
                  <InfoDetail>Text</InfoDetail>
                </Info>
                <Info>
                  <InfoTitle>Phone and fax</InfoTitle>
                  <InfoDetail>Phone</InfoDetail>
                  <InfoDetail>Fax</InfoDetail>
                </Info>
              </InfoColumn>
              <InfoColumn>
                <Info>
                  <InfoTitle>Camp website & email</InfoTitle>
                  <InfoDetail>Website</InfoDetail>
                  <InfoDetail>Email</InfoDetail>
                </Info>
                <Info>
                  <InfoTitle>Camp social</InfoTitle>
                  <InfoDetail>Facebook</InfoDetail>
                </Info>
              </InfoColumn>
              <InfoColumn>
                <Info>
                  <InfoTitle>Day camp</InfoTitle>
                  <BulletItem>Yes</BulletItem>
                </Info>
                <Info>
                  <InfoTitle>Sleep away camp</InfoTitle>
                  <BulletItem>Yes</BulletItem>
                </Info>
                <Info>
                  <InfoTitle>Camp accreditation</InfoTitle>
                  <InfoDetail>Info</InfoDetail>
                </Info>
              </InfoColumn>
              <InfoColumn>
                <Info>
                  <InfoTitle>Camp enrollment</InfoTitle>
                  <InfoDetail>100</InfoDetail>
                </Info>
                <Info>
                  <InfoTitle>Camp age range</InfoTitle>
                  <InfoDetail>10 - 20</InfoDetail>
                </Info>
                <Info>
                  <InfoTitle>Camp gender</InfoTitle>
                  <InfoDetail>Coed</InfoDetail>
                </Info>
              </InfoColumn>
            </Body>
          </CampInformation>
        </Segment>
        <Segment loading>
          <CampSpecialty>
            <Title>Camp Speciality</Title>
            <Body wrap>
              {[1, 2, 3].map(item => (
                <BulletItem key={uuidv1()}>Example</BulletItem>
              ))}
            </Body>
          </CampSpecialty>
        </Segment>
        <Segment loading>
          <CampExpertise>
            <Title>Camp Expertise</Title>
            <Body wrap>
              {[1, 2, 3].map(item => (
                <BulletItem key={uuidv1()}>Example</BulletItem>
              ))}
            </Body>
          </CampExpertise>
        </Segment>
      </ActionWrapper>
    )
  }
}

export default CampProfileLoading



// WEBPACK FOOTER //
// ./src/scenes/Camp/CampProfile/CampProfile.loading.js